import React from 'react';
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Box,
  Button,
} from '@material-ui/core';
import { Router } from 'config/i18n';
import Image from 'next/image';
import banner from '../../public/imgs/commercial-host/banner.webp';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    position: 'relative',
    height: theme.spacing(68.75),
  },
  Container: {
    height: '100% !important',
  },
  grid: {
    height: '100% !important',
  },
  headerImgBox: {
    overflow: 'hidden',
    backgroundColor: theme.palette.grey[600],
    position: 'absolute',
    zIndex: 0,
    height: theme.spacing(68.75),
    top: 0,
    right: 0,
    width: '100%',
  },
  headerImg: {
    height: '100%  !important',
    position: 'absolute',
    zIndex: 0,
    top: '0 !important',
    left: '0 !important',
    right: 'auto !important',
    bottom: 'auto !important',
    width: 'auto !important',
    minWidth: '100% !important',
    maxWidth: 'none !important',
    maxHeight: 'none !important',
    opacity: '0.5',
    [theme.breakpoints.only('md')]: {
      height: 'auto !important',
      minHeight: '100% !important',
    },
    [theme.breakpoints.up('lg')]: {
      width: '100% !important',
      height: 'auto !important',
      minHeight: '100% !important',
      margin: '0 !important',
    },
  },
  welcomeTxt: {
    textAlign: 'center',
    [theme.breakpoints.only('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  mainTitle: {
    fontSize: theme.typography.pxToRem(32),
    marginBottom: theme.spacing(3),
    fontWeight: 'bolder',
    color: theme.palette.common.white,
    fontFamily: theme.typography.fontFamilySecondary,
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(48),
      marginBottom: theme.spacing(4),
    },
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: '500',
    color: theme.palette.common.white,
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(22),
    },
  },
  getStarted: {
    boxShadow: 'none',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '500',
    borderRadius: 4,
    marginTop: theme.spacing(6),
  },
  contentGrid: {
    zIndex: 0,
  },
}));

const WelcomeBanner = ({ i18n }) => {
  const classes = useStyles();

  const handleBtnClick = () => {
    Router.push('/user/vehicles');
  };

  return (
    <>
      <Box className={classes.mainContainer}>

        <Box className={classes.headerImgBox}>
          <Image
            className={classes.headerImg}
            src={banner}
            alt={i18n('fe_commercial_host_banner_shared:become_commercial_host')}
            layout="fill"
            unoptimized
            placeholder="blur"
            priority
          />
        </Box>

        <Container className={classes.Container}>
          <Grid
            container
            justify="center"
            alignItems="center"
            spacing={3}
            className={classes.grid}
          >
            <Grid item xs={12} lg={6} className={classes.contentGrid}>
              <Box className={classes.welcomeTxt}>
                <Typography variant="h1" classes={{ root: classes.mainTitle }}>
                  {i18n('fe_commercial_host_banner_shared:become_commercial_host')}
                </Typography>
                <Typography
                  classes={{ root: classes.subTitle }}
                  variant="h3"
                >
                  {i18n('fe_commercial_host_banner_shared:banner_intro')}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleBtnClick}
                  classes={{ root: classes.getStarted }}
                >
                  {i18n('fe_commercial_host_banner_shared:sign_up')}
                </Button>
              </Box>
            </Grid>

          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default WelcomeBanner;
